<ngx-extended-pdf-viewer
        *ngIf="showPdf"
        [ignoreKeys]="['R']"
        [(page)]="pageNumber"
        [useBrowserLocale]="true"
        [base64Src]="pdfUrl"
        [textLayer]="true" >
</ngx-extended-pdf-viewer>